import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../appContext';
import Back from '../main/back';
import './midia-labs.css';
import MidiaLabsLabChoose from "./midia-labs-choose";
import MidiaLabsList from "./components/list/midia-labs-list";
import { USER_ROLES } from "../shared/constants/userRoles.constants";
import { TokenUtils } from "../shared/utils/TokenUtils";
import { Container } from "@material-ui/core";
import { useApi } from "../hooks/useApi";

const MidiaLabs = () => {
	const context = useContext(AppContext);
	const [ selectedLab, setSelectedLab ] = useState(null);
	const [ hasUploadPermission, setHasUploadPermission ] = useState(false);
	const [ permissionLoaded, setPermissionLoaded ] = useState(false);
	const [ hasModuleAccess, setHasModuleAccess ] = useState(false);
	const [ userLabs, setUserLabs ] = useState([]);
	const { get } = useApi();

	useEffect(() => {
		checkModuleAccess();
		checkUploadPermission();
		extractLabFromToken();
	}, []);

	const checkModuleAccess = () => {
		const hasAccess = TokenUtils.hasModuloMidiaLabs();
		setHasModuleAccess(hasAccess);
	};

	const checkUploadPermission = async () => {
		const tokenData = TokenUtils.getTokenData();
		const email = tokenData?.usuario?.email || '';
		const cpf = tokenData?.usuario?.cpf || '';

		try {
			const params = new URLSearchParams({ email, cpf });
			const data = await get(
				`${ process.env.REACT_APP_LABS_API }check_midia_labs_permission.php?${ params }`
			);

			if (data.status === 200) {
				setHasUploadPermission(data.has_permission);
			} else {
				setHasUploadPermission(false);
			}
		} catch (error) {
			setHasUploadPermission(false);
		} finally {
			setPermissionLoaded(true);
		}
	};

	const extractLabFromToken = () => {
		const labs = TokenUtils.extractLabsFromToken() || [];
		setUserLabs(labs);
	};

	const handleLabSelect = (lab) => {
		setSelectedLab(lab);
	};

	const handleBackToLabs = () => {
		setSelectedLab(null);
	};

	const isOptical = USER_ROLES.OPTICAL.some(role =>
		context.userSession.papel?.includes(role)
	);
	const isLab = USER_ROLES.LABORATORY.some(role =>
		context.userSession.papel?.includes(role)
	);
	const hasMultipleLabs = userLabs.length > 1;
	const shouldShowLabChoice = (isOptical || hasMultipleLabs) && !isLab;

	if (!context.userSession) {
		return (
			<div id="main-body" className="container">
				<Back items={[{ label: 'Seleção de Laboratório' }]} title="Mídia LABs" />
				<div className="text-center mt-5">
					<h3>Carregando...</h3>
				</div>
			</div>
		);
	}

	if (!hasModuleAccess) {
		return (
			<div id="main-body" className="container">
				<Back items={[{ label: 'Seleção de Laboratório' }]} title="Mídia LABs" />
				<div className="text-center mt-5">
					<h3>Acesso Negado</h3>
					<p>Você não possui acesso ao módulo Mídia LABs.</p>
					<p className="text-muted">Entre em contato com o administrador para solicitar acesso.</p>
				</div>
			</div>
		);
	}

	if (shouldShowLabChoice && !selectedLab) {
		return (
			<div className="x-body midia-labs-home" id="main-body">
				<main className=".x-web-ordering__main">
					<div className="x-web-ordering__container">
						<section className="x-web-ordering__left">
							<div>
								<Back items={[{ label: 'Seleção de Laboratório' }]} title="Mídia LABs" />
								{ userLabs.length > 0 && (
									<MidiaLabsLabChoose
										onSelectLab={ handleLabSelect }
										userLabs={ userLabs }
									/>
								) }
							</div>
							<div className="x-web-ordering__intro">
								<img src="image/modulos/Conecta_MidiaLABs.png" alt="Conecta Mídia LABs" className="guia-atacado-img" />
								<div className="x-web-ordering__intro--container">
									<p className="x-web-ordering__intro--subtitle">
										Dúvidas? Baixe nosso <a href="#" target="_blank" rel="noopener noreferrer" className="x-web-ordering__intro--link x-web-ordering__intro--subtitle-bold" id="midia-labs-guide-link">Guia do Conecta Mídia LABs</a>.
									</p>
								</div>
							</div>
						</section>
					</div>
				</main>
			</div>
		);
	}

	const breadcrumbItems = shouldShowLabChoice
		? [
			{ label: 'Seleção de Laboratório', onClick: handleBackToLabs },
			{ label: `Mídias de ${ selectedLab?.nome || 'Laboratório' }` },
		]
		: [{ label: `Mídias de ${ selectedLab?.nome || 'Laboratório' }` }];

	return (
		<div id="main-body" className="midia-labs-content">
			<Back items={ breadcrumbItems } title="Mídia LABs" />

			<div className="title-container">
				<h1 className="main-title">Mídia LABs</h1>
				<span className="title-shape"></span>
			</div>

			<Container maxWidth="lg" disableGutters>
				{ (selectedLab || isLab) && (
					<MidiaLabsList
						selectedLab={ selectedLab }
						hasUploadPermission={ hasUploadPermission }
						permissionLoaded={ permissionLoaded }
						onBack={ shouldShowLabChoice ? handleBackToLabs : null }
						isLabUser={ isLab }
					/>
				) }
			</Container>
		</div>
	);
};

export default MidiaLabs;
